import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import { Link } from "react-router-dom";
import { Row, Col, Layout, Input, Form, Button, Checkbox } from "antd";
import { graphql, compose } from "react-apollo";
import Recaptcha from "react-recaptcha";
import Cookies from "js-cookie";

import { linesToParagraphs } from "./common/Functions";
import { USER_PROFILE } from "./gql/query";
import { SEND_REQUEST } from "./gql/mutation";
import { Loading } from "../utils/loading";
import LandingHeader from "./common/Header";
import LandingFooter from "./common/Footer";

import "./css/contacts.css";

const { Content } = Layout;
const { TextArea } = Input;
const { Item } = Form;

const cookieTimeToLife = { expires: 14 };

class Contacts extends React.Component {
  static propTypes = {
    isLoggedIn: PropTypes.bool.isRequired
  };

  state = {
    isAgree: false,
    recaptcha: null,
    recaptchaNotice: false,
    error: null,
    thankYou: false
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }


  componentWillReceiveProps(nextProps) {
    !this.props.form.isFieldsTouched() && this._initialFormValue(nextProps)
  }

  _setInitialFormValue = data => {
    const { setFieldsValue, getFieldValue } = this.props.form;
    if (
      !getFieldValue("username") &&
      !getFieldValue("firstName") &&
      !getFieldValue("companyName")
    )
      setFieldsValue(data);
  };

  _initialFormValue = props => {
    if (props.isLoggedIn && props.data && !props.data.loading) {
      const {
        companyName,
        user: { firstName, username }
      } = props.data.data;
      this._setInitialFormValue({ username, firstName, companyName });
    } else if (!props.isLoggedIn) {
      const data = this._getCookies();
      if (data) this._setInitialFormValue(data);
    }
  };

  _getCookies = () => {
    const data = Cookies.get("guestData");
    if (data) return JSON.parse(data);
    return null;
  };

  _setCookies = ({ username, firstName, companyName }) => {
    Cookies.set(
      "guestData",
      { username, firstName, companyName },
      cookieTimeToLife
    );
  };

  _handleSubmit = e => {
    e.preventDefault();

    const { recaptcha, isAgree } = this.state;
    if (!this.props.isLoggedIn && !recaptcha) {
      this.setState({ recaptchaNotice: true });
    } else {
      this.setState({ recaptchaNotice: false });
    }
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if(this.state.recaptchaNotice) return false
        this.props
          .mutation({
            variables: { ...values, recaptcha, isAgree }
          })
          .then(({ data }) => {
            if (data.registerUser && data.registerUser.error)
              this.setState({ error: data.registerUser.error });
            else this.setState({ thankYou: true });
          })
          .catch(error => {
            console.error(error);
          });
        this._setCookies(values);
      } else console.error(err);
    });
  };

  _verifyCallback = recaptcha =>
    this.setState({ recaptcha, recaptchaNotice: false });

  _showBackendError = () => (
    <div className="landing__contacts--error">{this.state.error}</div>
  );

  render() {
    const { isLoggedIn, data } = this.props;
    const { formatMessage } = this.props.intl;
    const { getFieldDecorator } = this.props.form;

    const loading = isLoggedIn ? data && data.loading : false;
    let content = loading ? (
      <Loading />
    ) : (
      <Form onSubmit={this._handleSubmit}>
        <h2>
          <FormattedMessage
            id="landing.contacts_header"
            defaultMessage="Contact us, we are always open for new inquires"
            description="Form title"
          >
            {linesToParagraphs}
          </FormattedMessage>
        </h2>
        <Item>
          {getFieldDecorator("firstName", {
            rules: [
              {
                required: true,
                min: 2,
                message: formatMessage({
                  id: "register.name-required-error",
                  defaultMessage: "Please input your name"
                })
              }
            ]
          })(
            <Input
              placeholder={formatMessage({
                id: "landing.contacts_placeholder.firstName",
                defaultMessage: "Name"
              })}
            />
          )}
        </Item>
        <Item>
          {getFieldDecorator("username", {
            rules: [
              {
                required: true,
                message: formatMessage({
                  id: "register.contact-person-email-required-error",
                  defaultMessage: "Please input contact person's email"
                })
              },
              {
                type: "email",
                message: formatMessage({
                  id: "login.email-incorrect-error",
                  defaultMessage: "Please input correct email"
                })
              }
            ]
          })(
            <Input
              placeholder={formatMessage({
                id: "landing.contacts_placeholder.email",
                defaultMessage: "Email"
              })}
            />
          )}
        </Item>
        <Item>
          {getFieldDecorator("companyName", {
            rules: [
              {
                required: true,
                min: 2,
                message: formatMessage({
                  id: "register.company-required-error",
                  defaultMessage: "Please input your company name"
                })
              }
            ]
          })(
            <Input
              placeholder={formatMessage({
                id: "landing.contacts_placeholder.company",
                defaultMessage: "Your Company"
              })}
            />
          )}
        </Item>
        <Item>
          {getFieldDecorator("Comment", {
            rules: [
              {
                required: true,
                min: 5,
                message: formatMessage({
                  id: "register.comment-required-error",
                  defaultMessage: "Please input your comment"
                })
              }
            ]
          })(
            <TextArea
              row={5}
              placeholder={formatMessage({
                id: "landing.contacts_placeholder.comment",
                defaultMessage: "Comment"
              })}
            />
          )}
        </Item>
        {!isLoggedIn && (
          <Recaptcha
            ref={e => (this.recaptchaInstance = e)}
            sitekey="6LeG1mYUAAAAANtcySEmy3ruKOy9OuIEqaf3Ewdv"
            render="explicit"
            verifyCallback={this._verifyCallback}
            hl={formatMessage({
              id: "general.recaptchaLocale",
              defaultMessage: "en"
            })}
          />
        )}
        {this.state.recaptchaNotice && (
          <div className="ant-form-explain" style={{ color: "#f5222d" }}>
            <FormattedMessage
              id="register.rechapcha-required-error"
              defaultMessage="Prove that you are not a robot"
            />
          </div>
        )}
        <Checkbox
          value={this.state.isAgree}
          onChange={() =>
            this.setState(({ isAgree }) => ({ isAgree: !isAgree }))
          }
        >
          <FormattedMessage
            id="landing.contacts_agreement"
            defaultMessage="I agree to receive occasional emails from Conduster"
            description="lable for checkbox with agreement"
          />
        </Checkbox>
        <Button
          htmlType="submit"
          className="request__button"
          type="primary"
          size="large"
        >
          <FormattedMessage
            id="landing.contacts_sendMessage"
            defaultMessage="Send message"
            description="Form submit button"
          />
        </Button>
        {this.state.error && this._showBackendError()}
      </Form>
    );
    if (this.state.thankYou)
      content = (
        <div>
          <h2>
            <FormattedMessage
              id="landing.contacts_thankYou"
              defaultMessage="Your message has been sent"
              description="thank you"
            />
          </h2>
          <Link to="/">
            <Button className="request__button" type="primary" size="large">
              <FormattedMessage
                id="landing.homeButton"
                defaultMessage="Home"
                description="Home"
              />
            </Button>
          </Link>
        </div>
      );
    return (
      <Layout className="landing landing__contacts">
        <LandingHeader isLoggedIn={isLoggedIn}>
          <Link to="/">
            <span>Conduster</span>
          </Link>
        </LandingHeader>
        {/*___________________________________________________*/}
        {/*_________________ C O N T E N T ___________________*/}
        {/*___________________________________________________*/}
        <Content className="landing__content">
          <Row className="container" justify="space-between" type="flex">
            <Col className="landing__contacts--left" sm={24} md={12}>
              {content}
            </Col>
            <Col className="landing__contacts--right" sm={24} md={12}>
              {/*___________________________________________________*/}
              {/*_________________ A D D R E S S ___________________*/}
              {/*___________________________________________________*/}
              {/* <address>
                <p>
                  <FormattedMessage
                    id="landing.contacts_address"
                    defaultMessage="Bersenevskaya quay, 6"
                    description="Contacts address in the blue block"
                  />
                </p>
                <p>
                  <a
                    href={
                      "tel:" +
                      formatMessage({
                        id: "landing.contacts_phone",
                        defaultMessage: "+74997031336"
                      })
                    }
                  >
                    <FormattedMessage
                      id="landing.contacts_phone-label"
                      defaultMessage="Tel.: +7 (499) 703-13-36"
                      description="Contacts phone in the blue block"
                    />
                  </a>
                </p>
              </address> */}
            </Col>
          </Row>
          <div className="landing__content--image" />
        </Content>
        {/*___________________________________________________*/}
        {/*_________________ F O O T E R  ____________________*/}
        {/*___________________________________________________*/}
        <LandingFooter />
      </Layout>
    );
  }
}

export default compose(
  graphql(USER_PROFILE, { name: "data" }),
  graphql(SEND_REQUEST, { name: "mutation" })
)(Form.create()(injectIntl(Contacts)));



// WEBPACK FOOTER //
// ./src/components/landing/Contacts.js